const mutation = {
  // 设置商城规则
  UPDATE: (state, config) => {
    state.config = config
    state._updatedAt = Date.now()
  }
}

export default mutation
